import Grid from "@mui/material/Grid";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { RecipeCard } from "@thrivetribe/mvf.ui.molecules.recipe-card";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useGetRecipesQuery } from "redux/contentApiSlice";
import { RecipeType } from "types";
import "./RecipeListing.scss";

interface RecipeListingProps {
  heading?: React.ReactNode;
}

export const RecipeListing: React.FC<RecipeListingProps> = ({ heading }: RecipeListingProps) => {
  const [pageNum, setPageNum] = useState<number>(1);
  const [localRecipes, setLocalRecipes] = useState<RecipeType[]>([]);
  const [showLoadMore, setShowLoadMore] = useState<boolean>(false);
  const { data: recipes, error } = useGetRecipesQuery({
    limit: 6,
    pageRequested: pageNum,
  });

  useEffect(() => {
    setShowLoadMore((recipes?.length ?? 0) % 6 === 0);
    setLocalRecipes([...localRecipes, ...(recipes ?? [])]);
  }, [recipes]);

  useEffect(() => {
    if (!!error && "status" in error && error.status === 404) {
      setShowLoadMore(false);
    }
  }, [error]);

  return (
    <>
      <div className="recipe-list">
        {heading}
        <div className="recipe-list__cards">
          <Grid container rowSpacing={2} columnSpacing={{ sm: 1, md: 2 }}>
            {localRecipes?.map((x) => (
              <Grid item sm={12} md={6} lg={4} key={x.id}>
                <Link to={`/recipes/${x.slug}`}>
                  <RecipeCard
                    title={x.title}
                    description={x.introduction}
                    imgUrl={x.asset.file.url}
                    imgTitle={x.asset.file.fileName}
                    mealType={x.mealType[0]}
                    time={`${x.readyIn} mins`}
                    kCal={x.nutritionalBreakdown?.portion?.singleServing?.foodLabel.energyKcal.weight}
                    onClick={() => {
                      window.scroll(0, 0);
                    }}
                   />
                </Link>
              </Grid>
            ))}
          </Grid>
        </div>
        {showLoadMore && (
          <div className="recipe-list__load-more">
            <Button onClick={() => setPageNum(pageNum + 1)} variant="primary" tabIndex={0}>
              Load more
              <ButtonArrow />
            </Button>
          </div>
        )}
      </div>
    </>
  );
};